import { useCallback } from "react";

import {
  BlueprintSuggestions,
  searchBlueprintSuggestionsDictionary,
} from "shared/Blueprint/constants";
import useApplyFilter from "components/Filters/useApplyFilter";
import { Blueprint } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLabels from "ds/components/Table/Row/CellLabels";

import useBlueprintsAnalytics from "../../hooks/useBlueprintsAnalytics";

const APPLY_FILTERS_SUGGESTIONS = {
  searchSuggestionsDictionary: searchBlueprintSuggestionsDictionary,
};

const BlueprintsTableLabelsCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  // TODO: replace useApplyFilter hook with useCellFilterAction to avoid excessive rendering
  const { applyFilter, applyLabelFilter } =
    useApplyFilter<BlueprintSuggestions>(APPLY_FILTERS_SUGGESTIONS);

  const trackAnalytics = useBlueprintsAnalytics();

  const handleApplyLabelFilter = useCallback(
    (value: string) => {
      trackAnalytics("Label clicked", { type: BlueprintSuggestions.Label });
      applyLabelFilter(BlueprintSuggestions.Label)(value);
    },
    [trackAnalytics, applyLabelFilter]
  );

  const handleApplyFolderFilter = useCallback(
    (value: string) => {
      trackAnalytics("Label clicked", { type: BlueprintSuggestions.Folder });
      applyFilter(BlueprintSuggestions.Folder)(value);
    },
    [trackAnalytics, applyFilter]
  );

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels
        tags={blueprint.labels}
        applyLabelFilter={handleApplyLabelFilter}
        applyFolderFilter={handleApplyFolderFilter}
      />
    </TableSimpleCell>
  );
};

export default BlueprintsTableLabelsCell;
